import React, {PureComponent} from 'react';
import Modal from 'react-modal';
import '../css/SystemIntegratorView.css';
import SIOkasBoxes from './SIOkasBoxes';
import Cookies from 'js-cookie';
import Sorting from './Sorting';

// total boxes si pages

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    // minHeight: '10%',
    // maxHeight: '80%',
    height:'640px',
    overflow: 'auto',
    padding: '40px 90px 40px 90px',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
    // background: 'none !important'
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};

export default class SiTotalOkasBoxes extends PureComponent{
  constructor(props) {
  super(props);

  this.state = {
    modalIsOpen: this.props.activeModal,
    modalShowOkasBox: false,
    modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
    SiUsername: this.props.siCurrentData.si_userName,
    SiName: this.props.siCurrentData.si_name,
    errorMessage: [],
    currentBuilding: '',
    actualData: this.props.SiTotalOkasBoxes,
    SiTotalOkasBoxes: this.props.SiTotalOkasBoxes,
    sortedType: '',
    sortingStatus: {
      sortingName: '',
      defaultDown:  true
    },
    someElement: ''
  };
  this.openModal = this.openModal.bind(this);
  this.afterOpenModal = this.afterOpenModal.bind(this);
  this.closeModal = this.closeModal.bind(this);
}

openModal() {
  this.setState({modalIsOpen: true});
}    

afterOpenModal() {

}

closeModal() {
  this.setState({
    modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
  },()=>{
    setTimeout(()=>{
      this.setState({
        modalIsOpen: false,
      },()=>this.props.closeAllModal())
    }, 500);
  })
}
componentWillMount(){
  this.AllProjects()
}
    AllProjects = () =>{
        let element = this.state.SiTotalOkasBoxes.map((e,index)=>{    
        return   <tr>
        <td scope="col"  style={{ width: '50px', verticalAlign: 'middle' }}>{index+1}</td>
        <td scope="col" style={{ width: '20%', verticalAlign: 'middle' }}>{e.okasBox_version}</td>
        <td  scope="col" style={{ width: '20%', verticalAlign: 'middle' }}>{e.okasBox_serialNo}</td>
        <td  scope="col" style={{width: '20%', verticalAlign: 'middle' }}>{this.assignedBoxRender(e.okasBox_status)}</td>       
        <td scope="col" style={{width: '20%', verticalAlign: 'middle' }}> {e.okasBox_type === 'Master Controller' ? 'Master Studio' :  
                             e.okasBox_type === "VOD Box" ? "Media Studio" :
                             e.okasBox_type === "UVOD Box" ? "Ultra Media Studio" :
                             e.okasBox_type === "Audio Box" ? "Music Studio" : e.okasBox_type}</td>
      </tr>
      })
      this.setState({
        someElement: element
      })
      return element;
    }


    assignedBoxRender = (status) => {
      if (status === 'unassigned') {
        return <div style={{ height: '2.5vh', width: '3vw', backgroundColor: '#A9A9A9', borderRadius: "2.5vh", }}></div>
      } else if (status === 'Assigned SI') {
        return <div style={{ height: '2.5vh', width: '3vw', backgroundColor: '#f07e25', borderRadius: "2.5vh", }}></div>
      } else if (status === "Assigned Project") {
        return <div style={{ height: '2.5vh', width: '3vw', backgroundColor: '#78244c', borderRadius: "2.5vh", }}></div>
      } else if (status === "Assigned Distributor") {
        return <div style={{ height: '2.5vh', width: '3vw', backgroundColor: '#39beba', borderRadius: "2.5vh", }}></div>
      }
    }



    fetchIconType = (e) =>{
      if(e===this.state.sortingStatus.sortingName && this.state.sortingStatus.defaultDown){
        return 'fas fa-chevron-down pointer ml-2 float-right'
      }else if(e===this.state.sortingStatus.sortingName && !this.state.sortingStatus.defaultDown){
        return 'fas fa-chevron-up pointer ml-2 float-right'
      }else{
        return 'fas fa-chevron-down pointer ml-2 float-right icon-inactive'
      }
    }
    restoreData = (data) => {
      this.setState({
        siAllProjectData: data,     
      },()=>{
        this.AllProjects()
      })
    }
    sortingFunc = (type, searchValue) => {
      if (type !== 'search') {
        if(this.state.sortingStatus.sortingName===type){
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown:  !this.state.sortingStatus.defaultDown
          },
        },()=>{
          if(this.state.sortingStatus.sortingName===type && this.state.sortingStatus.defaultDown){
            Sorting(this.restoreData, type, this.state.actualData);      
          }else if(this.state.sortingStatus.sortingName===type && !this.state.sortingStatus.defaultDown){
            Sorting(this.restoreData, 'reverse', this.state.SiTotalOkasBoxes);  
          }
        })
      }else{
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown:  true
          },
        },()=>{
          if(this.state.sortingStatus.sortingName===type && this.state.sortingStatus.defaultDown){
            Sorting(this.restoreData, type, this.state.actualData);      
          }else if(this.state.sortingStatus.sortingName===type && !this.state.sortingStatus.defaultDown){
            Sorting(this.restoreData, 'reverse', this.state.SiTotalOkasBoxes);  
          }
        })
        }
      } else if (type === 'search') {
        type = 'search';
        Sorting(this.restoreData, type, this.state.actualData, searchValue);
      } else {
        type = 'reverse';
        Sorting(this.restoreData, type, this.state.actualData);
      }
    }


render(){
        return (
          <React.Fragment>
            <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}          
          className={this.state.modalStateAftereOpen}      
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
                <i class="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase mb-0 mt-4"  style={{ color: '#888888', fontSize: '30px', }}>{this.state.SiName}'s Boxes Details</h3>
<div className="row mt-3">
<table className="table">
                <thead className="tableHeaderColor" style={{borderRadius: '10px 10px 0px 0px'}}>
                    <th scope="col"  style={{ width: '50px', verticalAlign: 'middle' }}>ID</th>
                    <th scope="col" style={{ width: '20%', verticalAlign: 'middle' }}>
                    Version
                    <i class={this.fetchIconType('okasBox_version')} onClick={(e) => { this.sortingFunc('okasBox_version') }}>
                </i>
                    </th>
                    <th scope="col" style={{ width: '20%', verticalAlign: 'middle' }} >
                    Serial No
                    <i class={this.fetchIconType('okasBox_serialNo')} onClick={(e) => { this.sortingFunc('okasBox_serialNo') }}>
                </i>
                    </th>
                    <th scope="col" style={{ width: '20%', verticalAlign: 'middle' }}>
                    Status
                    <i class={this.fetchIconType('okasBox_status')} onClick={(e) => { this.sortingFunc('okasBox_status') }}>
                </i>
                    </th>
                    <th scope="col" style={{  width: '20%', verticalAlign: 'middle' }}>
                    Type
                    <i class={this.fetchIconType('okasBox_type')} onClick={(e) => { this.sortingFunc('okasBox_type') }}>
                </i>
                    </th>
                </thead>
                <tbody  style={{height: '350px'}}>              
                {/* {this.AllProjects()}*/}
                {this.state.someElement}               
                </tbody>
              </table>
              <div className="row w-100 mt-4" style={{marginLeft: '0',marginRight: '0'}}> 
              <div className="float-right ml-auto">
               <div className="btn btn-new-grey" onClick={this.closeModal}>Close</div>              
             </div>
              </div>
          
</div>          
        </Modal>
          </React.Fragment>
        );
    }
}
